import Reflux                     from 'reflux';
import DescriptorActions          from 'actions/descriptor_actions';
import Compiler                   from 'descriptor/compiler';
import StoreState                 from 'mixins/store_state';
import HasPrettyTime              from 'mixins/has_pretty_time';
import { isEmpty }                from 'lodash';

export default Reflux.createStore({
  mixins: [ StoreState, HasPrettyTime ],
  listenables: DescriptorActions,
  stateNamespace: 'descriptor',
  defaultVideoOptions: {
    shouldShowControlsDesktop: true,
    shouldShowNativeControlsMobile: true,
    shouldAutoPlay: false,
    watermark: null
  },
  onLoadJSON(descriptor, videoUrlFragment) {
    descriptor.videos.forEach((element, index) => {
      if(element.isIndexed) {
        element.videoIndex = index;
      }
    });
    descriptor.chapterList = descriptor.videos.slice(0);
    const inIndex = descriptor.chapterList.findIndex((video) => video.videoUrlFragment === videoUrlFragment);
    let ifiPlaceHolder, placeHolders;
    if(typeof descriptor.placeHolders !== 'undefined') {
      ifiPlaceHolder = descriptor.placeHolders.filter((inPlaceHolder) => inPlaceHolder.isIfi === true);
      placeHolders = descriptor.placeHolders.filter((inPlaceHolder) => inPlaceHolder.isIfi === false);
    }
    if(!isNaN(inIndex) && inIndex !== -1) {
      if(!isEmpty(ifiPlaceHolder)) {
        descriptor.chapterList.splice((inIndex + 1), 0, ifiPlaceHolder[0]);
      } else if(!isEmpty(descriptor.advertisement_videos[0])) {
        descriptor.chapterList.splice((inIndex + 1), 0, descriptor.advertisement_videos[0]);
        descriptor.videos.splice((inIndex + 1), 0, descriptor.advertisement_videos[0]);
      }
    } else {
      if(!isEmpty(ifiPlaceHolder)) {
        descriptor.chapterList.splice(1, 0, ifiPlaceHolder[0]);
      } else if(!isEmpty(descriptor.advertisement_videos[0])) {
        descriptor.chapterList.splice(1, 0, descriptor.advertisement_videos[0]);
        descriptor.videos.splice(1, 0, descriptor.advertisement_videos[0]);
      }
    }
    if(!isEmpty(placeHolders)) {
      descriptor.chapterList = descriptor.chapterList.concat(placeHolders);
    }
    this.compile(descriptor, videoUrlFragment);
  },
  getTitle(index) {
    return (index !== -1) ? this.state.videos[index].title : null;
  },
  getDescriptor() {
    return this.state;
  },
  isVideo() {
    return this.state.isVideo;
  },
  getInitialIndex() {
    return  this.state.initialIndex;
  },
  getVideo(index) {
    return this.state.videos[index];
  },
  getCCFileRoot(index) {
    return this.state.videos[index].ccFileRoot;
  },
  hasCCEnabled(index) {
    return this.state.videos[index].hasCc;
  },
  getCCInfo(index) {
    return this.state.videos[index].ccInfo[0];
  },
  getCCArray(index) {
    return this.state.videos[index].ccInfo;
  },
  getVideos() {
    return this.state.videos;
  },
  getVideoCount() {
    return this.state.videos.length;
  },
  compile(descriptor, videoUrlFragment) {
    const compiler = new Compiler(descriptor, videoUrlFragment);
    compiler.compile();
    this.setState(compiler.getDescriptor());
  }
});



/** WEBPACK FOOTER **
 ** ./modules/stores/descriptor_store.js
 **/